import { makeStyles } from '@material-ui/core';
import { alpha } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  /** Atrás do painel e do FAB: clique fora fecha o widget */
  widgetBackdrop: {
    zIndex: 1299,
    backgroundColor: alpha(theme.palette.common.black, theme.palette.type === 'dark' ? 0.35 : 0.12),
  },
  fab: {
    position: 'fixed',
    right: 20,
    bottom: 135,
    zIndex: 1300,
    overflow: 'visible',
    transition: 'transform 0.25s ease, background-color 0.2s ease, box-shadow 0.2s ease',
    [theme.breakpoints.down('sm')]: {
      right: 14,
      bottom: 136,
    },
  },
  fabHidden: {
    transform: 'translateX(80px)',
  },
  fabClosed: {
    boxShadow: theme.shadows[8],
    color: 'var(--wl-menu-header-icon, var(--wl-menu-icon, #ffffff))',
    '&.MuiFab-root': {
      color: 'var(--wl-menu-header-icon, var(--wl-menu-icon, #ffffff))',
    },
    '& svg': {
      color: 'var(--wl-menu-header-icon, var(--wl-menu-icon, #ffffff))',
    },
  },
  fabOpen: {
    color: 'var(--wl-menu-header-icon, var(--wl-menu-icon, #ffffff))',
    boxShadow: theme.shadows[6],
    '&.MuiFab-root': {
      color: 'var(--wl-menu-header-icon, var(--wl-menu-icon, #ffffff))',
    },
    '& svg': {
      color: 'var(--wl-menu-header-icon, var(--wl-menu-icon, #ffffff))',
    },
  },
  /** Badge absoluto dentro do próprio FAB para não "soltar" no layout */
  fabUnreadBadge: {
    position: 'absolute',
    top: -6,
    right: -6,
    zIndex: 1,
    display: 'grid',
    placeItems: 'center',
    minWidth: 18,
    height: 18,
    fontSize: '0.65rem',
    fontWeight: 700,
    lineHeight: 1,
    borderRadius: 9,
    boxSizing: 'border-box',
    fontVariantNumeric: 'tabular-nums',
    letterSpacing: '-0.02em',
    pointerEvents: 'none',
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText,
    boxShadow: '0 1px 4px rgba(15, 23, 42, 0.28)',
    border: `2px solid ${theme.palette.secondary.main}`,
  },
  chatToggleTab: {
    position: 'fixed',
    right: 0,
    bottom: 200,
    zIndex: 1301,
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.type === 'dark' ? theme.palette.divider : '#e5e7eb'}`,
    borderRight: 'none',
    borderRadius: '8px 0 0 8px',
    boxShadow: '-2px 0 8px rgba(0,0,0,0.08)',
    padding: '8px 5px',
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 3,
    userSelect: 'none',
    transition: 'opacity 0.2s ease',
    // No mobile a abinha continua sendo o único jeito de trazer o FAB de volta
    // (ele nasce recolhido), então ela precisa aparecer e ter alvo de toque.
    // A largura fica menor que 44px de propósito: encostada na borda direita,
    // a área de toque efetiva é ampliada pela própria borda da tela.
    [theme.breakpoints.down('sm')]: {
      padding: '12px 7px',
      minHeight: 44,
      justifyContent: 'center',
    },
  },
  chatToggleTabIcon: {
    fontSize: 13,
    color: '#9ca3af',
    [theme.breakpoints.down('sm')]: {
      fontSize: 16,
    },
  },
  chatToggleTabChevron: {
    fontSize: 13,
    color: '#9ca3af',
    [theme.breakpoints.down('sm')]: {
      fontSize: 16,
    },
  },
  /** Painel flutuante alinhado ao `dialogPaper` / modais do sistema */
  panelRoot: {
    position: 'fixed',
    right: 40,
    bottom: 195,
    width: 310,
    height: 450,
    zIndex: 1300,
    borderRadius: 16,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
    boxSizing: 'border-box',
    border: `1px solid ${theme.palette.type === 'dark' ? theme.palette.divider : '#e8edf2'}`,
    boxShadow:
      theme.palette.type === 'dark' ? theme.shadows[24] : '0 8px 32px rgba(15, 23, 42, 0.14)',
    backgroundColor: theme.palette.background.paper,
    [theme.breakpoints.down('sm')]: {
      right: 10,
      left: 10,
      bottom: 200,
      width: 'auto',
      height: '56vh',
      minHeight: 300,
      maxHeight: 460,
    },
  },
  hubHeader: {
    padding: theme.spacing(2, 2.25),
    borderBottom: `1px solid ${theme.palette.type === 'dark' ? theme.palette.divider : '#e8edf2'}`,
    backgroundColor: theme.palette.background.paper,
    flexShrink: 0,
  },
  hubHeaderTop: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  statusDot: {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: theme.palette.success.main,
    boxShadow: `0 0 0 3px ${alpha(theme.palette.success.main, 0.25)}`,
    flexShrink: 0,
  },
  hubKicker: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    fontSize: '1rem',
    fontWeight: 700,
    color: theme.palette.text.primary,
    letterSpacing: '0.01em',
  },
  hubHeaderActions: {
    display: 'flex',
    alignItems: 'center',
    gap: 2,
  },
  iconOnHeader: {
    color: theme.palette.text.secondary,
    padding: 8,
    '& .MuiSvgIcon-root': {
      color: 'inherit',
    },
    '&:hover': {
      backgroundColor: alpha(theme.palette.text.primary, 0.06),
    },
  },
  threadHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    padding: '10px 10px 10px 4px',
    borderBottom: `1px solid ${theme.palette.type === 'dark' ? theme.palette.divider : '#e8edf2'}`,
    backgroundColor: theme.palette.background.paper,
    flexShrink: 0,
  },
  threadHeaderText: {
    flex: 1,
    minWidth: 0,
  },
  threadTitle: {
    fontSize: '1rem',
    fontWeight: 700,
    color: theme.palette.text.primary,
    lineHeight: 1.25,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  threadSubtitle: {
    fontSize: '0.75rem',
    color: theme.palette.text.secondary,
    lineHeight: 1.35,
    marginTop: 2,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  searchRow: {
    padding: theme.spacing(1.25, 2),
    backgroundColor: theme.palette.type === 'dark' ? theme.palette.background.default : '#f8fafc',
    flexShrink: 0,
  },
  searchField: {
    '& .MuiOutlinedInput-root': {
      backgroundColor: theme.palette.background.paper,
      borderRadius: 10,
      fontSize: '0.875rem',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.type === 'dark' ? theme.palette.divider : '#e2e8f0',
    },
    '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.text.secondary,
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.main,
      borderWidth: 1,
    },
  },
  listArea: {
    flex: 1,
    minHeight: 0,
    overflowY: 'auto',
    backgroundColor: theme.palette.type === 'dark' ? theme.palette.background.default : '#f8fafc',
    ...theme.scrollbarStyles,
  },
  chatRowOuter: {
    display: 'flex',
    alignItems: 'stretch',
    borderBottom: `1px solid ${theme.palette.type === 'dark' ? theme.palette.divider : '#e8edf2'}`,
    transition: 'background-color 0.15s ease',
    '&:hover': {
      backgroundColor: alpha(theme.palette.primary.main, 0.04),
    },
  },
  chatRow: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 12,
    padding: '14px 16px',
    cursor: 'pointer',
    flex: 1,
    minWidth: 0,
    border: 'none',
    background: 'transparent',
    font: 'inherit',
    textAlign: 'left',
  },
  chatRowSelected: {
    backgroundColor: alpha(theme.palette.primary.main, 0.06),
    boxShadow: `inset 3px 0 0 ${theme.palette.primary.main}`,
  },
  chatRowActions: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    flexShrink: 0,
    padding: '6px 8px 6px 0',
    gap: 0,
  },
  chatRowActionBtn: {
    padding: 6,
    borderRadius: 8,
    color: theme.palette.text.secondary,
    '&:hover': {
      backgroundColor: alpha(theme.palette.text.primary, 0.06),
      color: theme.palette.primary.main,
    },
  },
  chatRowActionBtnDanger: {
    '&:hover': {
      backgroundColor: alpha(theme.palette.error.main, 0.08),
      color: theme.palette.error.main,
    },
  },
  chatRowAvatar: {
    width: 44,
    height: 44,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    backgroundColor: alpha(theme.palette.primary.main, 0.14),
    color: theme.palette.primary.main,
    '& svg': {
      fontSize: 24,
    },
  },
  chatRowAvatarUnread: {
    backgroundColor: alpha(theme.palette.success.main, 0.2),
    color: theme.palette.success.dark,
  },
  chatRowAvatarCount: {
    fontSize: '0.9rem',
    fontWeight: 800,
    lineHeight: 1,
    fontVariantNumeric: 'tabular-nums',
    letterSpacing: '-0.02em',
  },
  chatRowBody: {
    flex: 1,
    minWidth: 0,
  },
  chatRowTitle: {
    fontSize: '0.9375rem',
    fontWeight: 600,
    color: theme.palette.text.primary,
    lineHeight: 1.25,
    marginBottom: 4,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  chatRowPreview: {
    fontSize: '0.8125rem',
    color: theme.palette.text.secondary,
    lineHeight: 1.35,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  chatRowMeta: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    gap: 6,
    flexShrink: 0,
    paddingTop: 2,
  },
  chatRowDate: {
    fontSize: '0.7rem',
    fontWeight: 600,
    color: theme.palette.text.secondary,
    whiteSpace: 'nowrap',
  },
  unreadCount: {
    boxSizing: 'border-box',
    minWidth: 22,
    height: 22,
    padding: '0 6px',
    borderRadius: 11,
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    fontWeight: 800,
    display: 'inline-grid',
    placeItems: 'center',
    lineHeight: 1,
    fontVariantNumeric: 'tabular-nums',
    letterSpacing: '-0.01em',
  },
  /** Padding no pai evita overflow: `fullWidth` + margin horizontal cortava a direita */
  newChatCtaWrap: {
    flexShrink: 0,
    width: '100%',
    boxSizing: 'border-box',
    padding: theme.spacing(1.5, 2, 2),
  },
  /** CTA único para nova conversa — estilo outlined alinhado a modais (sem fill verde) */
  newChatCta: {
    width: '100%',
    margin: 0,
    borderRadius: 10,
    padding: theme.spacing(1.25, 2),
    textTransform: 'none',
    fontWeight: 600,
    fontSize: '0.875rem',
    boxShadow: 'none',
    borderWidth: 1,
    backgroundColor: theme.palette.background.paper,
    '&:hover': {
      boxShadow: 'none',
      backgroundColor: alpha(theme.palette.primary.main, 0.06),
    },
  },
  messagesArea: {
    position: 'relative',
    flex: 1,
    overflowY: 'auto',
    padding: '14px 14px 18px',
    ...theme.scrollbarStyles,
    backgroundColor: theme.palette.type === 'dark' ? theme.palette.background.default : '#eef2f7',
    fontFamily: theme.typography.fontFamily,
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale',
  },
  messagesAreaTyping: {
    paddingBottom: 56,
  },
  messageLeft: {
    width: 'fit-content',
    maxWidth: '100%',
    padding: theme.spacing(1.5, 2),
    borderRadius: 12,
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    border: `1px solid ${theme.palette.type === 'dark' ? theme.palette.divider : '#e2e8f0'}`,
    boxShadow: '0 1px 2px rgba(15, 23, 42, 0.06)',
    wordBreak: 'break-word',
    whiteSpace: 'pre-wrap',
    overflowWrap: 'break-word',
    fontFamily: theme.typography.fontFamily,
    boxSizing: 'border-box',
  },
  messageRight: {
    width: 'fit-content',
    maxWidth: '100%',
    padding: theme.spacing(1.5, 2),
    borderRadius: 12,
    backgroundColor: theme.palette.type === 'dark' ? '#1e3a2f' : '#d9fdd3',
    color: theme.palette.text.primary,
    boxShadow: '0 1px 2px rgba(15, 23, 42, 0.08)',
    wordBreak: 'break-word',
    whiteSpace: 'pre-wrap',
    overflowWrap: 'break-word',
    fontFamily: theme.typography.fontFamily,
    boxSizing: 'border-box',
  },
  messageSenderName: {
    fontSize: '0.8125rem',
    fontWeight: 600,
    letterSpacing: '-0.02em',
    color: theme.palette.primary.main,
    marginBottom: 4,
    display: 'block',
    fontFamily: theme.typography.fontFamily,
  },
  messageBody: {
    fontSize: '0.9375rem',
    lineHeight: 1.5,
    letterSpacing: '-0.011em',
    fontWeight: 400,
    color: 'inherit',
    fontFamily: theme.typography.fontFamily,
    '& p': { margin: 0 },
  },
  messageCaptionPlain: {
    fontSize: '0.9375rem',
    lineHeight: 1.5,
    letterSpacing: '-0.011em',
    fontWeight: 400,
    color: 'inherit',
    marginBottom: 6,
    display: 'block',
    fontFamily: theme.typography.fontFamily,
  },
  messageTime: {
    fontSize: '0.6875rem',
    fontWeight: 500,
    letterSpacing: '0.01em',
    color: theme.palette.text.secondary,
    display: 'inline',
    textAlign: 'right',
    lineHeight: 1.35,
    fontFamily: theme.typography.fontFamily,
  },
  messageTimeRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: 4,
    marginTop: 8,
    paddingTop: 2,
  },
  messageDeleteIcon: {
    padding: 4,
    marginLeft: 2,
    color: theme.palette.text.secondary,
    '&:hover': {
      color: theme.palette.error.main,
      backgroundColor: alpha(theme.palette.error.main, 0.08),
    },
  },
  messageRow: {
    display: 'flex',
    alignItems: 'flex-end',
    gap: 8,
    marginBottom: 12,
  },
  messageRowMine: {
    justifyContent: 'flex-end',
  },
  messageRowTheirs: {
    justifyContent: 'flex-start',
  },
  senderAvatar: {
    width: 26,
    height: 26,
    fontSize: '0.625rem',
    fontWeight: 700,
    flexShrink: 0,
  },
  messageStack: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: 'min(92%, 100%)',
    minWidth: 0,
  },
  messageStackMine: {
    alignItems: 'flex-end',
    marginLeft: 'auto',
  },
  messageStackTheirs: {
    alignItems: 'flex-start',
  },
  senderAboveVoice: {
    fontSize: '0.8125rem',
    fontWeight: 600,
    letterSpacing: '-0.02em',
    color: theme.palette.primary.main,
    marginBottom: 4,
    alignSelf: 'flex-start',
    fontFamily: theme.typography.fontFamily,
  },
  timeBelowVoice: {
    fontSize: '0.6875rem',
    fontWeight: 500,
    letterSpacing: '0.01em',
    color: theme.palette.text.secondary,
    marginTop: 4,
    lineHeight: 1.2,
    maxWidth: 300,
    fontFamily: theme.typography.fontFamily,
  },
  timeBelowVoiceMine: {
    alignSelf: 'flex-end',
    textAlign: 'right',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  timeBelowVoiceTheirs: {
    alignSelf: 'flex-start',
    textAlign: 'left',
  },
  composer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    gap: 8,
    position: 'relative',
    padding: theme.spacing(1.5, 2, 2),
    borderTop: `1px solid ${theme.palette.type === 'dark' ? theme.palette.divider : '#e8edf2'}`,
    backgroundColor: theme.palette.background.paper,
    flexShrink: 0,
  },
  composerRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    width: '100%',
  },
  '@keyframes internalChatWidgetMicPulse': {
    '0%, 100%': { opacity: 1 },
    '50%': { opacity: 0.55 },
  },
  composerInputShell: {
    flex: 1,
    minWidth: 0,
    borderRadius: 10,
    backgroundColor: theme.palette.type === 'dark' ? theme.palette.background.default : '#fff',
    border: `1px solid ${theme.palette.type === 'dark' ? theme.palette.divider : '#e2e8f0'}`,
  },
  composerTextField: {
    '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
    '& .MuiOutlinedInput-root': {
      borderRadius: 10,
      backgroundColor: 'transparent',
      alignItems: 'flex-start',
      color: theme.palette.text.primary,
    },
    '& .MuiOutlinedInput-input': {
      color: theme.palette.text.primary,
      fontFamily: theme.typography.fontFamily,
      fontSize: '0.9375rem',
      lineHeight: 1.5,
      letterSpacing: '-0.011em',
    },
    '& .MuiOutlinedInput-input::placeholder': {
      color: theme.palette.text.secondary,
      opacity: 1,
    },
  },
  recordingChronoOutside: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    flexShrink: 0,
    padding: '4px 2px',
    marginRight: 2,
  },
  recordingDot: {
    width: 10,
    height: 10,
    borderRadius: '50%',
    backgroundColor: '#f87171',
    flexShrink: 0,
    animation: '$internalChatWidgetMicPulse 1s ease-in-out infinite',
  },
  recordingTime: {
    fontSize: '0.875rem',
    fontWeight: 600,
    letterSpacing: '0.02em',
    color: theme.palette.text.secondary,
    fontVariantNumeric: 'tabular-nums',
  },
  recorderActions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    gap: 2,
    minHeight: 40,
  },
  composerIconWrap: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 40,
    height: 40,
    flexShrink: 0,
    boxSizing: 'border-box',
    lineHeight: 0,
  },
  actionIconMuted: {
    color: theme.palette.text.secondary,
  },
  cancelRecordIcon: {
    color: '#f87171',
  },
  confirmRecordIcon: {
    color: '#4ade80',
  },
  chatTitle: {
    fontWeight: 600,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  emptyState: {
    padding: 24,
    textAlign: 'center',
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
    lineHeight: 1.5,
  },
  typingBubbleFloating: {
    position: 'absolute',
    left: 16,
    top: -38,
    zIndex: 2,
    pointerEvents: 'none',
  },
  typingBubble: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 5,
    padding: '8px 12px',
    borderRadius: 14,
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.type === 'dark' ? theme.palette.divider : '#e2e8f0'}`,
    boxShadow: '0 1px 2px rgba(15, 23, 42, 0.06)',
    marginBottom: 0,
  },
  '@keyframes widgetTypingBounce': {
    '0%, 60%, 100%': { transform: 'translateY(0)' },
    '30%': { transform: 'translateY(-6px)' },
  },
  typingDot: {
    width: 7,
    height: 7,
    borderRadius: '50%',
    backgroundColor: theme.palette.text.disabled,
    animation: '$widgetTypingBounce 1s ease-in-out infinite',
  },
  typingDot2: { animationDelay: '0.18s' },
  typingDot3: { animationDelay: '0.36s' },
}));

export const useCreateChatDialogStyles = makeStyles((theme) => ({
  dialogPaper: {
    borderRadius: 16,
    overflow: 'hidden',
    maxHeight: 'min(90vh, 640px)',
    display: 'flex',
    flexDirection: 'column',
    border: `1px solid ${theme.palette.type === 'dark' ? theme.palette.divider : '#e8edf2'}`,
    boxShadow:
      theme.palette.type === 'dark' ? theme.shadows[24] : '0 8px 32px rgba(15, 23, 42, 0.14)',
    backgroundColor: theme.palette.background.paper,
  },
  dialogHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(2, 2.25),
    borderBottom: `1px solid ${theme.palette.type === 'dark' ? theme.palette.divider : '#e8edf2'}`,
    backgroundColor: theme.palette.background.paper,
    flexShrink: 0,
  },
  headerLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    minWidth: 0,
  },
  headerIcon: {
    width: 44,
    height: 44,
    borderRadius: 12,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    backgroundColor: alpha(theme.palette.primary.main, 0.12),
    '& svg': {
      fontSize: 22,
      color: theme.palette.primary.main,
    },
  },
  headerTitle: {
    fontSize: '1rem',
    fontWeight: 700,
    color: theme.palette.text.primary,
    lineHeight: 1.3,
  },
  headerSubtitle: {
    fontSize: '0.8rem',
    color: theme.palette.text.secondary,
    marginTop: 2,
    lineHeight: 1.35,
  },
  headerCloseBtn: {
    color: 'var(--wl-menu-header-icon, var(--wl-menu-icon, rgba(0, 0, 0, 0.54)))',
    padding: theme.spacing(1),
    '& .MuiSvgIcon-root': {
      color: 'inherit',
    },
    '&:hover': {
      backgroundColor: alpha(theme.palette.text.primary, 0.06),
    },
  },
  dialogContent: {
    flex: '1 1 auto',
    minHeight: 0,
    overflowY: 'auto',
    padding: theme.spacing(2, 2, 2.5),
    backgroundColor: theme.palette.type === 'dark' ? theme.palette.background.default : '#f8fafc',
  },
  sectionCard: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: 12,
    border: `1px solid ${theme.palette.type === 'dark' ? theme.palette.divider : '#e2e8f0'}`,
    padding: theme.spacing(2, 2),
    boxShadow: '0 1px 2px rgba(15, 23, 42, 0.04)',
  },
  sectionTitle: {
    fontSize: '0.8125rem',
    fontWeight: 700,
    letterSpacing: '0.06em',
    textTransform: 'uppercase',
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(1.75),
    paddingLeft: theme.spacing(1.25),
    borderLeft: `3px solid ${theme.palette.primary.main}`,
  },
  field: {
    marginBottom: theme.spacing(2),
    '& .MuiOutlinedInput-root': { borderRadius: 10 },
  },
  dialogActions: {
    padding: theme.spacing(1.5, 2),
    backgroundColor: theme.palette.background.paper,
    borderTop: `1px solid ${theme.palette.type === 'dark' ? theme.palette.divider : '#e8edf2'}`,
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(1),
    flexShrink: 0,
  },
  btn: {
    borderRadius: 8,
    textTransform: 'none',
    fontWeight: 600,
    fontSize: '0.875rem',
    minWidth: 100,
  },
}));
